import React, { HTMLProps, memo } from 'react';
import classnames from 'classnames';
import Element from '../../element';
import styles from './style.module.scss';

interface IProps extends HTMLProps<HTMLElement>{
    id?: string;
    className?: string;
    renderAs?: string;
    children: React.ReactNode;
    // size?: 'small' | 'medium' | 'large';
    domRef?: any;
}

function Section(props: IProps) {
    const { className, id, children, renderAs = 'section', size, ...rest } = props;
    return (
        <Element
            id={id}
            renderAs={renderAs}
            className={classnames(styles['bm-section'], className, {
                [`is-${size}`]: size,
            })}
            {...rest}
        >
            {children}
        </Element>
    );
}

export default memo(Section);
